import {Switch} from "@material-ui/core";
import React from "react";

export const SwitchType = props => {
    const {fieldValue = {}, setValue} = props;
    return (
        <Switch
            color={"primary"}
            checked={Boolean(fieldValue ? fieldValue.value : false)}
            onChange={(e) => setValue(e, {label: '', value: e.target.checked})}
            size={"small"}
        />
    )
}